<!--
 * @Description: 客户激活编辑
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <accountActivationBaseMessage :disabled="true" formItemView :permissionPage="permissionBasic" :data="data" :reviewHistory="reviewHistory"/>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import AccountActivationBaseMessage
  from '@/views/overseasSales/customerCenter/accountActivation/components/DetailForm.vue'
import { newClientEvaluationDetail, newClientEvaluationReviewHistory } from '@/api/overseasSales/newClientEvaluation'
const route = useRoute()
const data = ref({})
// 获取详情
const fetch = () => {
  if (route.query.accountActivationId) {
    newClientEvaluationDetail({ id: route.query.accountActivationId as unknown as number }).then((res) => {
      if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
        res.data.business.businessTypeSelect = res.data.business.businessType[0]
      }
      data.value = res.data
    })
  }
}
const reviewHistory = ref<any[]>([])
const fetchReviewHistory = async () => {
  const res = await newClientEvaluationReviewHistory({ id: route.query.accountActivationId as unknown as number })
  reviewHistory.value = res.data
}
const permissionBasic = {
  save: 'ofbu_potential_edit_btn',
  editCode: 'ofbu_potential_edit_name_or_code_btn'
}
onMounted(() => {
  fetch()
  fetchReviewHistory()
})
</script>
<script lang="ts">
export default { name: 'DcCosOFbuAccountActivationDetail' }
</script>
<style lang="scss" scoped></style>
